import { Notification , Email} from '../models/interfaces/notification';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { IResponse } from '../models/interfaces/response.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private apiURL = environment.apiUrl;
  private url = `${this.apiURL}notifications`;

  constructor(private http: HttpClient) { }

  getAllNotifications(): Observable<Notification[]> {
    return this.http.get<Notification[]>(this.url);
  }

  getUserNotifications(param: {} = {}): Observable<IResponse<Notification>> {
    const params = new HttpParams({ fromObject: param });
    return this.http.get<IResponse<Notification>>(`${this.url}/user-notifications?${params}`);
  }

  getNotification(id: string): Observable<Notification> {
    return this.http.get<Notification>(`${this.url}/${id}`);
  }

  getUnreadNotificationNumber(): Observable<{ count: number }> {
    return this.http.get<{ count: number }>(`${this.url}/user-unread-numbers`);
  }

  createNotifications(notification: Notification): Observable<Notification> {
    return this.http.post<Notification>(this.url, notification);
  }

  createNotificationsForCustomeUser(notification: Notification, id: any): Observable<Notification> {
    return this.http.post<Notification>(`${this.url}/${id}`, notification);
  }

  readNotifications(id: string): Observable<Notification> {
    return this.http.patch<Notification>(
      `${this.url}/read/${id}`, {}
    );
  }

  deleteNotifications(id: string): Observable<any> {
    return this.http.delete<any>(`${this.url}/${id}`);
  }

  searchUsersByEmail(email: string): Observable<Email[]> {
    return this.http.get<Email[]>(`${this.apiURL}admin/users/search-users-by-email/${email}`);
  }

  markAllAsRead(): Observable<any> {
    return this.http.put(`${this.url}/mark-all-read`,{});
  }

  getCountOfUnreadNotifications(): Observable<any> {
    return this.http.get(`${this.apiURL}notifications/user-unread-numbers`)
  }
}
